import { useContext } from 'react'
import { AdminLastUpdate } from '../../../types'
import { ProfileImage } from '../../../ui/ProfileImage'
import { Tooltip } from '../../../ui/Tooltip'
import { combine, formatDate } from '../../../utils'
import { PreferencesContext } from '../../../ui/PreferencesContext'
import Chip from '../../../ui/Chip'

interface ModifiedTagProps {
    admin: AdminLastUpdate
}

export const ModifiedTag = ({ admin }: ModifiedTagProps) => {
    const [preferences] = useContext(PreferencesContext)
    const tooltip = (
        <Chip title={combine(admin.first_name, admin.last_name)} subtitle={admin.email} />
    )
    return (
        <Tooltip content={tooltip}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <ProfileImage admin={admin} size="small" />
                {formatDate(preferences, admin.created_at)}
            </div>
        </Tooltip>
    )
}
